import Vue from 'vue';
import Router from 'vue-router';
import NewsPage from '@/components/view/NewsPage.vue';
import HomePage from '@/components/view/HomePage.vue';
import AboutUsPage from '@/components/view/AboutUsPage.vue';
// import ProjectPage from '@/components/view/ProjectPage.vue';
import EquipmentPage from '@/components/view/EquipmentPage.vue';
// import NanoPage from '@/components/view/NanoPage.vue';
import ProductListPage from '@/components/view/ProductListPage.vue';
import ProductDetailPage from '@/components/view/ProductDetailPage.vue';
import ProjectDetailPage from '@/components/view/ProjectDetailPage.vue';
import NewDetailPage from '@/components/view/NewDetailPage.vue';
import ErrorPage from '@/components/view/ErrorPage.vue';
import WenJuanPage from '@/components/view/WenJuanPage.vue';
import DigitalPage from '@/components/view/DigitalPage.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/news',
    name: 'News',
    component: NewsPage
  }
  ,
  {
    path: '/about',
    name: 'About',
    component: AboutUsPage
  },
  // {
  //   path: '/project',
  //   name: 'Project',
  //   component: ProjectPage
  // },
  {
    path: '/equipment',
    name: 'Equipment',
    component: EquipmentPage
  },
  // {
  //   path: '/nano',
  //   name: 'Nano',
  //   component: NanoPage
  // },
  {
    path: '/productsList',
    name: 'productsList',
    component: ProductListPage
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: ProductDetailPage
  },
  {
    path: '/projectDetail',
    name: 'projectDetail',
    component: ProjectDetailPage
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: NewDetailPage
  },
  {
    path: '/error',
    name: 'errorPage',
    component: ErrorPage
  },
  {
    path: '/wenjuan',
    name: 'wenjuan',
    component: WenJuanPage
  },
  {
    path: '/digital',
    name: 'digital',
    component: DigitalPage
  },
  {
    path: '*',
    redirect: '/'  // 所有未匹配的路由都会重定向到首页
  },
  
];

const router = new Router({
  mode: 'hash', // 可以选择使用 'hash' 或 'history'
  routes
});

export default router;
